module.exports = __webpack_public_path__ + "img/help_statistics2.d2f0bb70.png";